import React, { useState } from "react";
import { Brand, Locale } from "../context/AppProvider";
import { useAppContext } from "../hooks/useAppContext";
import DropDownArrow from "./SVGIcons/DropDownArrow";
import BrandIcon from "./BrandIcon";
import useWindowWidth from "../hooks/useWindowWidth";

export type BrandProps = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  rotation?:
    | "-rotate-270"
    | "-rotate-180"
    | "-rotate-90"
    | "rotate-0"
    | "rotate-90"
    | "rotate-180"
    | "rotate-270";
};

const BrandButton = React.forwardRef<HTMLDivElement, BrandProps>(
  ({ showModal, setShowModal, rotation }, ref) => {
    const { brand } = useAppContext();
    const width = useWindowWidth();

    return (
      <div
        className="group relative flex cursor-pointer items-center gap-2"
        onClick={() => {
          setShowModal((prev) => !prev);
        }}
        ref={ref}
      >
        <div className={`flex items-center gap-2`}>
          <BrandIcon brand={brand} />
          <span
            className={`select-none text-sm font-semibold transition-colors group-hover:text-blue-solid-blue6 ${showModal ? "text-blue-solid-blue6" : "text-grayscale-solid-g10"} transition-transform duration-[250ms]`}
          >
            {brand === Brand.MD
              ? "Marvelous Designer"
              : brand === Brand.CLOSET
                ? "CLO-SET"
                : brand === Brand.CLOSET_CONNECT
                  ? "CONNECT"
                  : brand === Brand.ALLINONE
                    ? "All In One"
                    : "CLO"}
          </span>
        </div>
        <DropDownArrow
          className={`transition-transform duration-[250ms] ${showModal ? `${rotation} fill-blue-solid-blue6` : "fill-grayscale-solid-g10"} ${width <= 700 ? "-rotate-180" : ""} size-3 transition-colors group-hover:fill-blue-solid-blue6`}
        />
      </div>
    );
  },
);

export default BrandButton;
